import { compactPrimaryButton } from "../ui/buttonStyles.js";
import { Ico } from "../icons/icons.jsx";

/** Empty / no-results state for type catalog cards (§6.8.8). */
export function TypeCatalogEmptyState({ c, A, icon, message, hint, onAction, actionLabel, showActionIcon = true }) {
  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "48px 24px", textAlign: "center", gap: 10 }}>
      {icon ? (
        <div style={{ width: 48, height: 48, borderRadius: 12, background: `${A}12`, border: `1px solid ${A}30`, color: A, display: "grid", placeItems: "center" }}>
          {icon}
        </div>
      ) : null}
      <div style={{ fontSize: 14, fontWeight: 700, color: c.text }}>{message}</div>
      {hint ? <p style={{ margin: 0, fontSize: 12, color: c.sub, maxWidth: 320, lineHeight: 1.5 }}>{hint}</p> : null}
      {onAction && actionLabel ? (
        <button type="button" onClick={onAction} style={{ ...compactPrimaryButton(A), marginTop: 8 }}>
          {showActionIcon ? Ico.plus : null}
          {actionLabel}
        </button>
      ) : null}
    </div>
  );
}
